import React, { useEffect } from 'react';
import { useLanguage } from '../../../hooks/useLanguage';
import { aside as frAside } from '../../../locales/fr/aside';
import { aside as arAside } from '../../../locales/ar/aside';
import { aside as esAside } from '../../../locales/es/aside';
import useMyAppStore from '../../../stores/myAppStore';

const translations = {
  fr: frAside,
  ar: arAside,
  es: esAside
};

const Profile = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const { setPageTitle } = useMyAppStore();

  useEffect(() => {
    setPageTitle(t.routes.profile);
  }, [lang, t.routes.profile, setPageTitle]);

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        {lang === 'ar' ? 'الملف الشخصي' : 'Profil'}
      </h2>
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            {lang === 'ar' ? 'اسم المستخدم' : 'Nom d\'utilisateur'}
          </label>
          <input
            type="text"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            placeholder={lang === 'ar' ? 'أدخل اسم المستخدم' : 'Entrez votre nom d\'utilisateur'}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            {lang === 'ar' ? 'البريد الإلكتروني' : 'Email'}
          </label>
          <input
            type="email"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            placeholder={lang === 'ar' ? 'أدخل البريد الإلكتروني' : 'Entrez votre email'}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            {lang === 'ar' ? 'كلمة المرور' : 'Mot de passe'}
          </label>
          <input
            type="password"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            placeholder={lang === 'ar' ? 'أدخل كلمة المرور' : 'Entrez votre mot de passe'}
          />
        </div>
        <div className="flex justify-end">
          <button
            type="button"
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {lang === 'ar' ? 'حفظ التغييرات' : 'Enregistrer les modifications'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile; 